module.exports = __webpack_public_path__ + "img/logo-full.3847e4da.png";